import { createTheme } from '@mui/material/styles'

const customTheme = {
    cssVariables: true,
    breakpoints: {
        values: {
            xs: 0, // Mobile baseline
            sm: 360, // Larger phones (unchanged)
            md: 760, // Tablets/small laptops (up from 900)
            lg: 1024, // Standard desktops (up from 1200)
            xl: 1440, // Large desktops
            xxl: 1920,
        },
    },

    typography: {
        fontFamily: 'MonaSans, sans-serif',  // default
        hero: {
            fontSize: 'clamp(40px, 8vw, 80px)',
            fontWeight: 900,
            fontStyle: 'italic',
            fontFamily: 'MonaSansCondensed, sans-serif',
            whiteSpace: 'pre-line',
        },
        h1: {
            fontSize: 'clamp(32px, 6vw, 70px)',
            fontWeight: 900,
            fontStyle: 'italic',
            textTransform: 'uppercase',
            fontFamily: 'MonaSansCondensed, sans-serif',
            whiteSpace: 'pre-line',
        },
        h2: {
            fontSize: 'clamp(30px, 4vw, 60px)',
            fontWeight: 900,
            textTransform: 'uppercase',
            fontStyle: 'italic',
            fontFamily: 'MonaSansCondensed, sans-serif',
            whiteSpace: 'pre-line',
        },
        h3: {
            fontSize: 'clamp(26px, 2.5vw, 40px)',
            fontWeight: 900,
            fontStyle: 'italic',
            fontFamily: 'MonaSansCondensed, sans-serif',
            whiteSpace: 'pre-line',
        },
        h4: {
            fontSize: 'clamp(24px, 2.4vw, 36px)',
            fontWeight: 900,
            fontStyle: 'italic',
            fontFamily: 'MonaSansCondensed, sans-serif',
            whiteSpace: 'pre-line',
        },
        subtitle1: {
            fontSize: 'clamp(16px, 2.1vw, 24px)',
            fontWeight: 400,
            whiteSpace: 'pre-line',
        },
        subtitle2: {
            fontSize: 'clamp(16px, 2.1vw, 24px)',
            fontFamily: 'MonaSansCondensed, sans-serif',
            fontStyle: 'italic',
            fontWeight: 400,
            whiteSpace: 'pre-line',
        },
        body1: {
            fontSize: 'clamp(14px, 1.5vw, 16px)',
            fontWeight: 400,
            whiteSpace: 'pre-line',
        },
        body2: {
            fontSize: 'clamp(16px, 1.8vw, 18px)',
            fontWeight: 400,
            whiteSpace: 'pre-line',
        },
    },

    palette: {
        mode: 'light',
        primary: {
            light: '#D60004',
            main: '#D60004',
            dark: '#A30000',
            contrastText: '#FFFFFF',
        },
        secondary: {
            light: '#FFF',
            main: '#FFFFFF',
            dark: '#FFF',
            contrastText: '#000000',
        },
        info: {
            light: '#e0e0e0',
            main: '#9e9e9e',
            dark: '#9e9e9e',
            contrastText: '#e0e0e0',
        },
    },

    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                    fontWeight: 900,
                    fontStyle: 'italic',
                    fontSize: 'clamp(16px, 1.5vw, 20px)',
                    textTransform: 'uppercase',
                    fontFamily: 'MonaSansCondensed, sans-serif',
                },
            },
        },
    },

}
const theme = createTheme(customTheme)

export default theme
